import ApiGroupEmptyInstance from './ApiGroupEmptyInstance';

export default ApiGroupEmptyInstance;
